
import React, {useEffect, useState} from 'react';
import {BrowserRouter as Router, Route, Switch} from 'react-router-dom';
import AOS from 'aos';
import {connect} from 'react-redux';
import {addLoftyUser, deleteLoftytoken} from './actions/auth.actions';
import { loftySendVisitProject } from './util/visitsprojects';

// pages
import principalsxyjhi from './pages/principalsxyjhi/principalsxyjhi'
import sobrenosotrosnmlqp from './pages/sobrenosotrosnmlqp/sobrenosotrosnmlqp'
import proyectosproductivosigdy from './pages/proyectosproductivosigdy/proyectosproductivosigdy'
import impactosocial2hdiq from './pages/impactosocial2hdiq/impactosocial2hdiq'
import contactovc142 from './pages/contactovc142/contactovc142'
import campaasxtmme from './pages/campaasxtmme/campaasxtmme'
import transparenciai2sojk from './pages/transparenciai2sojk/transparenciai2sojk'
import convenios2pssf from './pages/convenios2pssf/convenios2pssf'


// css
import './App.css';
import 'aos/dist/aos.css';

AOS.init();

function initSwiper() {
  // eslint-disable-next-line no-undef
  const swiper = new Swiper('.mySwiper', {
    spaceBetween: 30,
    centeredSlides: true,
    autoplay: false,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });
  // console.log('swiper :>> ', swiper);
}

const App = ({loftytoken, addLoftyUserApp, deleteLoftytokenApp}) => {

  // agregando iniciación para el Swipper
  useEffect(() => {
    setTimeout(() => {
      initSwiper();
    }, 2000);
  }, []);

  useEffect(() => { loftySendVisitProject() }, []);

  

  return (
    <Router>
      <Switch>
			<Route exact path="/" component={principalsxyjhi} />
			<Route exact path="/sobrenosotros" component={sobrenosotrosnmlqp} />
			<Route exact path="/proyectos" component={proyectosproductivosigdy} />
			<Route exact path="/impacto" component={impactosocial2hdiq} />
			<Route exact path="/contacto" component={contactovc142} />
			<Route exact path="/campanas" component={campaasxtmme} />
			<Route exact path="/transparencia" component={transparenciai2sojk} />
			<Route exact path="/convenios" component={convenios2pssf} />

      </Switch>
    </Router>
  );
}

const mapStateToProps = (state) => state.auth;

const mapDispatchToProps = (dispatch) => ({
  addLoftyUserApp: (user) => dispatch(addLoftyUser(user)),
  deleteLoftytokenApp: () => dispatch(deleteLoftytoken()),
});

export default connect(mapStateToProps, mapDispatchToProps)(App);

